import { ArrowLeftIcon } from '@repo/studio-design-system-ui-icons/arrows/arrow-left'
import { ArrowRightIcon } from '@repo/studio-design-system-ui-icons/arrows/arrow-right'
import { tw } from 'utils/classnames'
import { useRootScroll } from 'hooks/use-root-scroll'
const decidePagesToRender = (page: number, count: number): (number | 'pre' | 'post')[] => {
  if (count === 0) {
    return [1]
  }

  if (count < 9) {
    return Array(count)
      .fill(true)
      .map((item, index) => index + 1)
  }

  if (page < 8) {
    return Array(8)
      .fill(true)
      .map((item, index) => index + 1)
  }

  if (page === count) {
    return [1, 2, 3, 'pre', page - 2, page - 1, page]
  }

  if (page + 1 === count) {
    return [1, 2, 3, 'pre', page - 2, page - 1, page, page + 1]
  }

  if (page + 2 === count) {
    return [1, 2, 3, 'pre', page - 2, page - 1, page, page + 1, page + 2]
  }

  if (page > 7) {
    return [1, 2, 3, 'pre', page - 2, page - 1, page, page + 1, page + 2, 'post']
  }

  return []
}

export function SearchPagination({
  currPage,
  totalPages,
  onChangePage,
  previousText,
  nextText,
}: {
  currPage: number
  totalPages: number
  onChangePage(page: number): void
  previousText: string
  nextText: string
}) {
  const { handleScrollToRootOnNextFrame } = useRootScroll()
  const pagesToRender = decidePagesToRender(currPage, totalPages)

  return (
    <nav className="font-inter flex w-full flex-row justify-between">
      <button
        disabled={currPage <= 1}
        className="text-14 flex items-center gap-1 text-gray-100 outline-none focus-visible:outline disabled:opacity-30"
        onClick={() => {
          onChangePage(currPage - 1)
          handleScrollToRootOnNextFrame()
        }}
      >
        <ArrowLeftIcon className="size-6" />
        <span className="hidden md:flex">{previousText}</span>
      </button>

      <div className="flex min-w-0 justify-center">
        {pagesToRender.map(item => {
          return (
            <button
              key={`pagination_${item}`}
              onClick={() => {
                // oxlint-disable-next-line no-nested-ternary, unicorn/no-nested-ternary
                onChangePage(item === 'pre' ? 4 : item === 'post' ? currPage : item)
                handleScrollToRootOnNextFrame()
              }}
              className={tw(
                ((item !== 'pre' && item !== 'post' && currPage === Number(item)) ||
                  totalPages === 0) &&
                  'text-service-white bg-violet-700',
                'flex h-[40px] w-[40px] items-center justify-center rounded text-[14px] outline-none focus-visible:outline',
              )}
            >
              {item !== 'pre' && item !== 'post' ? item : '...'}
            </button>
          )
        })}
      </div>

      <button
        disabled={currPage >= totalPages}
        className="text-14 flex items-center gap-1 text-gray-100 outline-none focus-visible:outline disabled:opacity-30"
        onClick={() => {
          onChangePage(currPage + 1)
          handleScrollToRootOnNextFrame()
        }}
      >
        <span className="hidden md:flex">{nextText}</span> <ArrowRightIcon className="size-6" />
      </button>
    </nav>
  )
}
